// src/plugins/loading/Loading.vue
<template>
    <div v-if="show" class="loading-overlay">
        <div class="loading-spinner"></div>
    </div>
</template>

<script>
export default {
    name: 'Loading',
    data() {
        return {
            show: false
        }
    },
    methods: {
        start() {
            this.show = true
        },
        stop() {
            this.show = false
        }
    }
}
</script>

<style scoped>
.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
}

.loading-spinner {
    width: 50px;
    height: 50px;
    border: 5px solid #f3f3f3;
    border-radius: 50%;
    border-top: 5px solid #3498db;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>